import React, { useState } from "react";
import styled from "styled-components";

import { Box } from "vqp-common";
import { Input, Button } from "../common";
import { Box as MuiBox } from "@material-ui/core";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px;
`;

const Card = styled(Box)`
  padding: 20px;
`;

const InputContainer = styled(MuiBox)`
  display: flex;
  flex: 1 1 1 auto;
  gap: 32px;
  & button {
    margin-top: 2px;
  }
`;

const Title = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.textBold};
`;

const TotalClients = styled.div`
  font-size: 12px;
  justify-self: end;
  & span:first-child {
    font-weight: 700;
  }
`;

export const ClientsFilter = ({ onFilter, totalClients }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");

  const handleChangeName = (value) => {
    setName(value);
  };

  const handleChangeEmail = (value) => {
    setEmail(value);
  };
  const handleChangeDocumentNumber = (value) => {
    setDocumentNumber(value);
  };

  const handleFilter = (e) => {
    e.preventDefault();
    onFilter({ name, email, documentNumber });
  };

  return (
    <Wrapper>
      <Title>Busca por clientes</Title>
      <form onSubmit={handleFilter}>
        <Card style={{}}>
          <InputContainer>
            <Input
              value={name}
              onChange={handleChangeName}
              placeholder="Busca por nome..."
            />
            <Input
              value={email}
              onChange={handleChangeEmail}
              placeholder="Busca por email..."
            />
            <Input
              value={documentNumber}
              onChange={handleChangeDocumentNumber}
              placeholder="Busca por CPF..."
            />
            <Button className="success" type="submit" width={"80px"}>
              Buscar
            </Button>
          </InputContainer>
          <TotalClients>
            <span>N° de clientes:&nbsp;</span>
            <span>{totalClients}</span>
          </TotalClients>
        </Card>
      </form>
    </Wrapper>
  );
};
